import { createSlice } from "@reduxjs/toolkit"


const historicalParams = createSlice({
    name : 'historicalParamsData',
    initialState : {
        paramsArray : []
    },
    reducers : {
        setParams : (state:any, action:any) => {
            // (state.paramsArray).push(action.payload)
            state.paramsArray = action.payload
        }
    }
})


export const { setParams }:any = historicalParams.actions;
export default historicalParams.reducer;